import './assets/main.css';

import 'bootstrap';
import 'primeicons/primeicons.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { definePreset, palette } from '@primevue/themes';
import { registerModules } from "./register-modules";
import { createHead } from '@unhead/vue/client';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import PrimeVue from 'primevue/config';
import App from './App.vue';
import router from './router';
import AuthStorePlugin from './plugins/authStore';
import keycloakService from '@services/keycloakService';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import DatePicker from 'primevue/datepicker'; 
import DataTable from 'primevue/datatable';
import Column from 'primevue/column'; 
import Card from 'primevue/card';
import Dialog from 'primevue/dialog';
import Message from 'primevue/message';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Select from 'primevue/select';
import ToggleSwitch from 'primevue/toggleswitch';
import ToggleButton from 'primevue/togglebutton';
import ConfirmDialog from 'primevue/confirmdialog';
import Textarea from 'primevue/textarea';
import Checkbox from 'primevue/checkbox';
import FileUpload from 'primevue/fileupload';

import ConfirmationService from 'primevue/confirmationservice';
import Aura from '@primevue/themes/aura';
import { primeVueLocale, primeVuePassThrough } from './plugins/primeVueConfig';

import ToastService from 'primevue/toastservice';
import logger from './utils/logger';

registerModules({
});

const appPreset = definePreset(Aura, {
  semantic: {
    primary: palette('#003865'),
    colorScheme: {
      light: {
        formField: {
           disabledBackground: '#f1f1f1',
        }
      }
    }
  }
});

const pinia = createPinia();

pinia.use(piniaPluginPersistedstate);

const app =  createApp(App);

app.config.errorHandler = (err) => {
    logger.error(err);
  };

app.use(pinia);

app.component('PvButton', Button);
app.component('PvInputText', InputText);
app.component('PvTabs', Tabs);
app.component('PvTab', Tab);
app.component('PvTabList', TabList);
app.component('PvTabPanels', TabPanels);
app.component('PvTabPanel', TabPanel);
app.component('PvSelect', Select);
app.component('PvInputMask', InputMask);
app.component('PvDatePicker', DatePicker);
app.component('PvDataTable', DataTable);
app.component('PvColumn', Column);
app.component('PvCard', Card);
app.component('PvDialog', Dialog);
app.component('PvMessage', Message);
app.component('PvToggleSwitch', ToggleSwitch);
app.component('PvToggleButton', ToggleButton);
app.component('PvConfirmDialog', ConfirmDialog);
app.component('PvTextarea', Textarea);
app.component('PvCheckbox', Checkbox);
app.component('PvInputNumber', InputNumber);
app.component('PvFileUpload', FileUpload);

app.use(PrimeVue, {
  ripple: true,
  locale: primeVueLocale,
  pt: primeVuePassThrough,
  theme: {
    preset: appPreset,
    options: {
      darkModeSelector: 'light-only',
      cssLayer: false
    } 
  }
});
app.use(ToastService);
app.use(ConfirmationService);

app.use(createHead());

keycloakService.CallInit().then(() => {
  app.use(AuthStorePlugin, { pinia });
  app.use(router);
  app.mount('#app');
});
